import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import App from './App.tsx'
import './index.css'
import { msalConfig } from './authConfig'
import { setMsalInstance } from './services/authService'

// Handle corrupted MSAL cache gracefully
let msalInstance: PublicClientApplication;
try {
  msalInstance = new PublicClientApplication(msalConfig)
} catch (error) {
  console.error('Failed to initialize MSAL, clearing cache:', error)
  // Clear localStorage and sessionStorage to remove corrupted MSAL cache
  localStorage.clear()
  sessionStorage.clear()
  // Retry initialization
  msalInstance = new PublicClientApplication(msalConfig)
}

// Initialize MSAL instance for auth service
setMsalInstance(msalInstance)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MsalProvider>
  </React.StrictMode>,
)
